/**
 * Landing Header — GenesisBox
 *
 * Sticky top bar for the public landing page (`/`). Mirrors the structure of
 * the Genesis Frameworks company site header (wordmark left, nav + CTA right)
 * but uses the live GenesisBox neon-glass theme so the front door is
 * continuous with the login page and the /drive app behind it.
 */

import { Box, Button, Stack, Typography } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

const NAV_LINKS: { label: string; href: string }[] = [
  { label: 'What it does', href: '#features' },
  { label: 'Viewer', href: '#viewer' },
  { label: 'Sharing', href: '#sharing' },
];

export function LandingHeader() {
  return (
    <Box
      component="header"
      sx={{
        position: 'sticky',
        top: 0,
        zIndex: 10,
        backdropFilter: 'blur(16px)',
        background: 'rgba(11, 11, 13, 0.62)',
        borderBottom: '1px solid rgba(143,245,255,0.08)',
      }}
    >
      <Box
        sx={{
          maxWidth: 1200,
          mx: 'auto',
          px: { xs: 2, md: 4 },
          height: 64,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
        }}
      >
        {/* Wordmark */}
        <Stack direction="row" alignItems="center" spacing={1.25}>
          <Box
            component="img"
            src="/icon-192.png?v=4"
            alt=""
            sx={{
              width: { xs: 36, sm: 40 },
              height: { xs: 36, sm: 40 },
              minWidth: 36,
              minHeight: 36,
              borderRadius: 1.75,
              border: '1px solid rgba(143,245,255,0.18)',
              objectFit: 'cover',
            }}
          />
          <Typography sx={{ fontWeight: 800, letterSpacing: '-0.02em', fontSize: 18 }}>
            GENESISBOX
          </Typography>
        </Stack>

        {/* Nav + CTA */}
        <Stack direction="row" alignItems="center" spacing={{ xs: 1, md: 3 }}>
          <Stack
            direction="row"
            spacing={3}
            sx={{ display: { xs: 'none', md: 'flex' } }}
          >
            {NAV_LINKS.map((link) => (
              <Typography
                key={link.href}
                component="a"
                href={link.href}
                className="font-label"
                sx={{
                  fontSize: 11,
                  color: 'text.secondary',
                  textDecoration: 'none',
                  transition: 'color 160ms ease',
                  '&:hover': { color: '#8ff5ff' },
                }}
              >
                {link.label}
              </Typography>
            ))}
          </Stack>
          <Button
            component={RouterLink}
            to="/login"
            variant="contained"
            sx={{
              bgcolor: 'rgba(143,245,255,0.12)',
              color: '#8ff5ff',
              border: '1px solid rgba(143,245,255,0.28)',
              borderRadius: 2,
              textTransform: 'none',
              fontWeight: 700,
              px: 2.25,
              py: 0.75,
              '&:hover': { bgcolor: 'rgba(143,245,255,0.2)', borderColor: 'rgba(143,245,255,0.45)' },
            }}
          >
            Sign in
          </Button>
        </Stack>
      </Box>
    </Box>
  );
}
